import { LitElement, html } from '@hh/global.js'

class CollectionProductGrid extends LitElement {
  constructor() {
    super()
  }

  connectedCallback() {
    super.connectedCallback()
    this.restoreScrollItem()
  }

  disconnectedCallback() {
    super.disconnectedCallback()
  }

  restoreScrollItem() {
    const anchorId = location.hash
    if (!anchorId) return

    const productCardEl = document.querySelector(anchorId)
    if (!productCardEl) return

    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual'

      document.addEventListener('beforeunload', () => {
        history.scrollRestoration = 'auto'
      })
    }

    setTimeout(() => {
      productCardEl.scrollIntoView({
        behavior: 'smooth',
      })
    }, 250)
  }

  render() {
    return html`<slot></slot>`
  }
}

customElements.define('collection-product-grid', CollectionProductGrid)
